import { render, staticRenderFns } from "./header.vue?vue&type=template&id=4f62c4b7&scoped=true&"
import script from "./header.vue?vue&type=script&lang=js&"
export * from "./header.vue?vue&type=script&lang=js&"
import style0 from "./header.vue?vue&type=style&index=0&id=4f62c4b7&scoped=true&lang=less&"
import style1 from "./header.vue?vue&type=style&index=1&id=4f62c4b7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f62c4b7",
  null
  
)

export default component.exports